export type Locale = "en" | "vi" | "es" | "id" | "th" | "lo" | "pt";

export const LOCALES: Locale[] = ["en", "vi", "es", "id", "th", "lo", "pt"];

export const DEFAULT_LOCALE: Locale = "en";

export const LOCALE_META: Record<
  Locale,
  { label: string; short: string; flag: string }
> = {
  en: { label: "English", short: "EN", flag: "🇬🇧" },
  vi: { label: "Tiếng Việt", short: "VI", flag: "🇻🇳" },
  es: { label: "Español", short: "ES", flag: "🇪🇸" },
  id: { label: "Bahasa", short: "ID", flag: "🇮🇩" },
  th: { label: "ภาษาไทย", short: "TH", flag: "🇹🇭" },
  lo: { label: "ພາສາລາວ", short: "LO", flag: "🇱🇦" },
  pt: { label: "Português", short: "PT", flag: "🇵🇹" },
};

export const STORAGE_KEY = "teado-locale";
